// extracted by mini-css-extract-plugin
export default {"page":"wacb97","content":"yhpQxI","logo":"DgF_jF","title":"wfSMm0","retryButton":"LgwTGq"};